import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/xlogo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["BlogNavigation"] */ "/app/src/components/blog/blog-navigation.tsx");
